import { Column, Entity, Index, JoinColumn, ManyToOne } from 'typeorm';
import { BaseEntity } from './base.entity';
import { PromoEntity } from './promo.entity';

// Item assignment by category. Categories here are the storefront-
// facing `item.category` text values (the same ones the homepage
// Category Tiles widget surfaces) — NOT the unrelated `category`
// table. We deliberately key on the name string so admins can target
// the same categories they curate in the storefront-categories admin
// without a parallel id-mapping layer. Engine evaluation matches
// each cart line's `item.category` against this list (case-sensitive,
// exact). The `role` matches promo_item.role semantics
// (BUY = qualifier, GET = reward).
@Index('promo_category_pk', ['fkPromoId', 'categoryName', 'role'], {
	unique: true,
})
@Entity('promo_category')
export class PromoCategoryEntity extends BaseEntity {
	@Column('int', { name: 'fk_promo__id', unsigned: true })
	public fkPromoId!: number;

	/**
	 * The exact `item.category` string. Treat as the customer-facing
	 * category identifier — see CategoryAdminListItemDto for the
	 * canonical admin shape (name + displayName overlay).
	 */
	@Column('varchar', { name: 'categoryName', length: 255 })
	public categoryName!: string;

	@Column('varchar', { name: 'role', length: 8, default: () => "'BUY'" })
	public role!: 'BUY' | 'GET';

	@ManyToOne(() => PromoEntity, (promo) => promo.promoCategories, {
		onDelete: 'CASCADE',
		onUpdate: 'RESTRICT',
	})
	@JoinColumn([{ name: 'fk_promo__id', referencedColumnName: 'id' }])
	public fkPromo!: PromoEntity;
}
